module.exports = __webpack_public_path__ + "static/neol-leeming-6033a9b8d7ecbdad9eb529cbbf170085.webp";